import { createFileRoute, useParams } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { CourseCalendarView } from '@/views/calendar/course-calendar-view.tsx';

// Course Calendar tab (ADR-020): this course's due dates + quiz windows +
// attendance sessions + COURSE events; ASSISTANT+ teachers can CRUD events.
export const Route = createFileRoute('/_learner/courses_/$id/calendar')({
  component: CalendarTab,
});

function CalendarTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/calendar' });
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <CourseCalendarView courseId={id} user={user} />;
}
